<ng-container *transloco="let t; read:'journal.settingsBar'">
	<div class="settings-header">
		<p>{{ t('loggedAs') }}</p>
		<h1>{{ (loggedUser$ | async).name }}</h1>
	</div>

	<div class="settings-wrapper">

		<div class="single-row">
			<div class="row-main">
				<p>1. {{ t('view.limitOfEntriesInOverview') }}</p>
				<label for="entriesLimit" class="select-label">
					<span *ngIf="!overviewEntriesLimit" class="spinner-border"></span>
					<select
						class="bare-input"
						id="entriesLimit"
						[formControl]="formRef.get(keys['overview.entriesLimit'])">
						<option *ngFor="let limit of overviewEntriesLimit"
								[hidden]="!overviewEntriesLimit"
								[selected]="(limit === formRef.get(keys['overview.entriesLimit']).value)"
								[value]="limit"
						>{{ limit }}</option>
					</select>
				</label>
			</div>
			<div class="row-info">
				<p>{{ t('journalInfo.infoEntriesOverviewLimit') }}</p>
			</div>
		</div>

		<div class="single-row">
			<div class="row-main">
				<p>2. {{ t('documentation.foldedAll') }}</p>
				<div class="switch-btn">
					<div class="form-check form-switch">
						<input type="checkbox" class="form-check-input" id="foldEntries"
							   [value]="formRef.get('foldedAll').value"
							   [formControl]="formRef.get('foldedAll')">
						<label class="form-check-label" for="foldEntries"></label>
					</div>
				</div>
			</div>
			<div class="row-info">
				<p>{{ t('journalInfo.infoFoldedAll') }}</p>
			</div>
		</div>

		<div class="single-row">
			<div class="row-main">
				<p>3. {{ t('view.numberOfEntriesPerPage') }}</p>
				<label for="entriesPerPage" class="select-label">
					<span *ngIf="!entriesPerPage" class="spinner-border"></span>
					<select
						class="bare-input"
						id="entriesPerPage"
						[formControl]="formRef.get('list.entriesPerPage')">
						<option *ngFor="let entriesNumber of entriesPerPage"
								[hidden]="!entriesPerPage"
								[selected]="(entriesNumber === formRef.get('list.entriesPerPage').value)"
								[value]="entriesNumber"
						>{{ entriesNumber }}</option>
					</select>
				</label>
			</div>
			<div class="row-info">
				<p>{{ t('journalInfo.infoEntriesPerPage') }}</p>
			</div>
		</div>

		<div class="single-row c-mb-1">
			<div class="row-main">
				<p>4. {{ t('view.extendEntryTypes') }}</p>
				<label class="select-label ng-select-label" for="entryTypeExtended">
					<span *ngIf="!(entryTypes$ | async)" class="spinner-border"></span>
					<ng-select
						class="custom"
						id="entryTypeExtended"
						[formControl]="entryTypeControl"
						[items]="(entryTypes$ | async)"
						[multiple]="true"
						[closeOnSelect]="false"
						[hideSelected]="false"
						bindLabel="type"
						bindValue="slug"
						[placeholder]="t('view.selectEntryType')"
						[compareWith]="compareWithIndex"
						[clearable]="false">
						<ng-template ng-option-tmp let-item="item" let-index="index" let-item$="item$">
							<div class="option" title="{{item.type}}">
								<span class="option-content">{{item.type}}</span>
								<input class="checkbox" id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/>
								<span class="checkmark"></span>
							</div>
						</ng-template>
						<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
							<button class="btn btn-sm btn-outline-primary" type="button"
									*ngFor="let item of items | slice:0:2">
								<span class="ng-value-icon left" (click)="clear(item);" aria-hidden="true"><i class="fa-solid fa-xmark"></i></span>
								<span class="ng-value-label">{{item.type}}</span>
							</button>
							<button class="btn btn-sm btn-outline-primary" type="button"
									*ngIf="items.length > 2">
								<span class="ng-value-label">{{items.length - 2}}&nbsp;{{t('more')}}</span>
							</button>
						</ng-template>
					</ng-select>
				</label>
			</div>
			<div class="row-info">
				<p>{{ t('journalInfo.entryTypesInfo') }}</p>
			</div>
		</div>

		<div class="single-row c-mb-1">
			<div class="row-main">
				<p>5. {{ t('view.defaultTemplate') }}</p>
				<label for="defaultTemplate" class="select-label">
					<span *ngIf="!(templates$ | async)" class="spinner-border"></span>
					<select
						class="bare-input"
						id="defaultTemplate"
						[formControl]="formRef.get('edit.defaultTemplate')">
						<option *ngFor="let template of (templates$ | async)"
								[hidden]="!(templates$ | async)"
								[class.templId]="(template.templateId === formRef.get('edit.defaultTemplate').value)"
								[selected]="(template.templateId === formRef.get('edit.defaultTemplate').value)"
								[value]="template.templateId"
						>{{ template.name }}</option>
					</select>
				</label>
			</div>
			<div class="row-info">
				<p>{{ t('journalInfo.infoDefaultTemplate') }}</p>
			</div>
		</div>

		<div class="single-row c-mb-1">
			<div class="row-main">
				<p>6. {{ t('documentation.toggleUnfoldContent') }}</p>
				<div class="switch-btn">
					<div class="form-check form-switch">
						<input type="checkbox" class="form-check-input" id="unfoldContent"
							   [value]="formRef.get('unfoldContent').value"
							   [formControl]="formRef.get('unfoldContent')">
						<label class="form-check-label" for="unfoldContent"></label>
					</div>
				</div>
			</div>
			<div class="row-info">
				<p>{{ t('journalInfo.infoContentUnfold') }}</p>
			</div>
		</div>

		<div class="single-row c-mb-1">
			<div class="row-main">
				<p>7. {{ t('documentation.contentLinesNumber') }}</p>
				<label for="contentLines" class="select-label">
					<span *ngIf="!(templates$ | async)" class="spinner-border"></span>
					<select
						class="bare-input"
						id="contentLines"
						[formControl]="formRef.get('foldContentLinesNumber')">
						<option *ngFor="let linesNum of contentLinesNum"
								[selected]="((numberOfLines$ | async) === formRef.get('foldContentLinesNumber').value)"
								[value]="linesNum"
						>{{ linesNum }}</option>
					</select>
				</label>
			</div>
			<div class="row-info">
				<p>{{ t('journalInfo.infoContentLinesNumber') }}</p>
			</div>
		</div>

		<div class="single-row">
			<div class="row-main">
				<p>8. {{ t('documentation.editDrawingsView') }}</p>
				<div class="switch-btn">
					<div class="form-check form-switch">
						<input type="checkbox" class="form-check-input" id="focusSchema"
							   [value]="formRef.get('focusSchema').value"
							   [formControl]="formRef.get('focusSchema')">
						<label class="form-check-label" for="focusSchema"></label>
					</div>
				</div>
			</div>
			<div class="row-info">
				<p>{{ t('journalInfo.editDrawingsFocusSchema') }}</p>
			</div>
		</div>

	</div>
</ng-container>
